// extracted by mini-css-extract-plugin
export default {"textarea":"styles_textarea__S8vWI","label":"styles_label__A8A3I","errorText":"styles_errorText__GVk9W"};